import { Sizes } from '../types';
import { disableScrolling, enableScrolling } from '../utils/helpers';

class Header {
  $header: JQuery<HTMLElement>;
  $body: JQuery<HTMLElement>;
  $hamburger: JQuery<HTMLElement>;
  $nav: JQuery<HTMLElement>;

  headerIsOpened: boolean;
  isScrollingDisabled: boolean;

  constructor() {
    this.$header = $('.header');
    this.$body = $('body');
    this.$hamburger = this.$header.find('.header__hamburger');
    this.$nav = this.$header.find('.header__nav');

    this.headerIsOpened = false;
    this.isScrollingDisabled = false;

    this.init();
  }

  init() {
    this.$hamburger.on('click', this.onHamburgerClick.bind(this));
  }

  onHamburgerClick() {
    if (!this.headerIsOpened) {
      this.openNav();
    } else {
      this.closeNav();
    }
  }

  openNav() {
    disableScrolling();
    this.$nav.attr('aria-expanded', 'true');
    this.$hamburger.attr('aria-expanded', 'true');
    this.$header.addClass('is-opened');

    this.headerIsOpened = true;
    this.isScrollingDisabled = true;
  }

  closeNav() {
    this.$nav.attr('aria-expanded', 'false');
    this.$hamburger.attr('aria-expanded', 'false');
    this.$header.removeClass('is-opened');

    if (this.isScrollingDisabled) {
      enableScrolling();
      this.isScrollingDisabled = false;
    }

    this.headerIsOpened = false;
  }

  onResize(sizes: Sizes) {
    if (this.headerIsOpened) {
      this.closeNav();
    }
  }
}

export default Header;
